import { render, staticRenderFns } from "./PracticeJournal.vue?vue&type=template&id=20678ac8&scoped=true&"
import script from "./PracticeJournal.vue?vue&type=script&lang=js&"
export * from "./PracticeJournal.vue?vue&type=script&lang=js&"
import style0 from "./PracticeJournal.vue?vue&type=style&index=0&id=20678ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20678ac8",
  null
  
)

export default component.exports